export const SET_RANGE = 'question-game/ageRange/SET_RANGE'

export function setRange(range) {
  return {
    type: SET_RANGE,
    range
  }
}
